import { detectBOM } from "./bom";
import { Decoder } from "./decoder";
import { Encoder } from "./encoder";
import { Encoding } from "./encoding";
import { splitRequirements } from "./splitRequirements";

interface Writer {
  write(data: Uint8Array): Promise<void>;
}

export class RequirementsTxt {
  private _lines: string[];

  private _crlf: boolean;

  private _encoder: Encoder;

  constructor(lines: string[], crlf: boolean, encoder: Encoder) {
    this._lines = lines;
    this._crlf = crlf;
    this._encoder = encoder;
  }

  get lines(): string[] {
    return this._lines;
  }

  get crlf(): boolean {
    return this._crlf;
  }

  static async read(buffer: Uint8Array): Promise<RequirementsTxt> {
    const bom = detectBOM(buffer);
    const encoder = bom?.newEncoder() || new Encoder(Encoding.UTF8, null);
    const decoder = bom?.newDecoder() || new Decoder(Encoding.UTF8, null);

    const content = decoder.decode(buffer);
    const lines = splitRequirements(content);

    const crlf = content.includes("\r\n");

    return new RequirementsTxt(lines, crlf, encoder);
  }

  async write(writable: Writer): Promise<void> {
    const lineEnding = this._crlf ? "\r\n" : "\n";
    const content = this._lines.join(lineEnding);
    const encodedContent = this._encoder.encode(content);

    await writable.write(encodedContent);
  }

  private _add(requirement: string): void {
    for (const line of this._lines) {
      if (line.includes(requirement)) {
        return;
      }
    }

    const lastIndex = this._lines.length - 1;
    if (lastIndex >= 0 && this._lines[lastIndex] === "") {
      this._lines[lastIndex] = requirement;
      this._lines.push("");
    } else {
      this._lines.push(requirement);
      this._lines.push("");
    }
  }

  add(...requirements: string[]): void {
    requirements.forEach((req) => {
      this._add(req);
    });
  }
}
